import posthog from 'posthog-js'
import React, {useEffect, useState} from 'react'
import {Row, Block} from 'jsxstyle'
import {ReactComponent as SearchIcon} from '../../common/assets/search-icon.svg'

interface SearchBarProps {
  placeholder?: string
  onSearch: (query?: string) => void
  initialValue?: string
}

const SearchBar: React.FC<SearchBarProps> = ({placeholder = 'Search', onSearch, initialValue}) => {
  const [query, setQuery] = useState('')

  useEffect(() => {
    setQuery(initialValue || '')
  }, [initialValue])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value)
  }

  const handleSearch = (trigger: 'click' | 'keydown') => {
    onSearch(query.trim() ? query : undefined)
    posthog.capture('search_triggered', {
      trigger_method: trigger,
    })
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch('keydown')
    }
  }

  const handleInputFocus = () => {
    posthog.capture('searchbar_clicked')
  }

  return (
    <Row
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      maxWidth="550px"
      padding="0 10px"
      height="40px"
      border="1px solid #1E90FF"
      borderRadius="20px"
      backgroundColor="#FFF"
      boxSizing="border-box"
    >
      <Block
        component="input"
        props={{
          placeholder,
          value: query,
          onChange: handleInputChange,
          onKeyDown: handleKeyDown,
          onFocus: handleInputFocus,
        }}
        flex="1"
        border="none"
        outline="none"
        fontSize="16px"
        fontFamily="Poppins, sans-serif"
        color="#333"
        padding="0 10px"
      />

      <Block width="1px" height="100%" backgroundColor="#1E90FF" />

      <Block
        component="button"
        props={{onClick: () => handleSearch('click')}}
        cursor="pointer"
        display="flex"
        alignItems="center"
        justifyContent="center"
        backgroundColor="transparent"
        border="none"
        height="100%"
        width="79px"
        padding="0"
      >
        <SearchIcon width={20} height={20} color="#1E90FF" />
      </Block>
    </Row>
  )
}

export default SearchBar
